<template>
  <v-switch
    dense
    hide-details
    :label="label"
    v-model="isSwitchOn"
    class="mt-0 pt-0"
  ></v-switch>
</template>

<script>
export default {
  name: "MultipleSwitch",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Multiple answer",
    },
  },
  computed: {
    isSwitchOn: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
  },
};
</script>

<style>
</style>